import { render, staticRenderFns } from "./SPFreelancerRegistrationFinished.vue?vue&type=template&id=5f3455f0&scoped=true"
import script from "./SPFreelancerRegistrationFinished.vue?vue&type=script&lang=js"
export * from "./SPFreelancerRegistrationFinished.vue?vue&type=script&lang=js"
import style0 from "./SPFreelancerRegistrationFinished.vue?vue&type=style&index=0&id=5f3455f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3455f0",
  null
  
)

export default component.exports